import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { DefaultFormComponent, fadeInOut, fadeInOut2, FormServiceInterface, ToastService, UserServiceInterface } from '@hutsix/ngxh6';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-known-client-form',
    templateUrl: './known-client-form.component.html',
    styleUrls: ['./known-client-form.component.scss'],
    animations: [fadeInOut, fadeInOut2],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class KnownClientFormComponent extends DefaultFormComponent {
    requiredFields: string[] = ['contact'];

    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('UserService') public userService: UserServiceInterface,
        public location: Location,
        public cdRef: ChangeDetectorRef,
        public toastr: ToastService,
    ) {
        super(formService, userService, location, cdRef);
    }

    submit(): void {
        this.submitted.emit({ type: 'cache', data: this.form.model, timestamp: new Date().getTime() });
    }

    onModelChange($e): void {
        super.onModelChanged($e);
    }

    isFormValid(formRef: NgForm): boolean {
        if (!formRef || !formRef.form || !formRef.form.value.form) {
            return false; // Invalid if form or its value is not available
        }

        const value = formRef.form.value.form;

        // Check that all required fields have valid (non-empty) values
        return this.requiredFields.every(field => value[field] !== undefined && value[field] !== null && value[field] !== '');
    }

    getView(view: any) {
        // Convert the lightswitch to a checkbox
        view.children.requiresReferral.vars.block_prefixes = view.children.requiresReferral.vars.block_prefixes.filter(prefix => prefix !== 'lightswitch');

        return view;
    }
}
